import { Injectable } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { WSService } from 'projects/core/src/include/service';
import { Observable } from 'rxjs';
import { DossierField, DossierPhase } from '../dossier';

@Injectable({
  providedIn: 'root'
})
export class DossierPhasesService extends WSService<DossierPhase> {

  constructor() { super("dossierphases");}

  getFieldsToShow(id_type):Observable<DossierField[]>{
    return Globals.ws.requestUrl("dossierphases","getFieldsToShow",[id_type]);
  }

}
